import { createSlice } from '@reduxjs/toolkit';
// import sum from 'lodash/sum';
// import uniqBy from 'lodash/uniqBy';
// utils
import axios from '../../utils/axios';
//
import { dispatch } from '../store';

// ----------------------------------------------------------------------
const flatChilds = (a, v, level = 0) => {
  v.forEach((e) => {
    a.push({ ...e, level });
    if (e.childs.length > 0) {
      flatChilds(
        a,
        e.childs.filter((c) => c !== null),
        level + 1
      );
    }
  });
};

const initialState = {
  isLoading: false,
  error: null,
  places: [],
  placesOrder: [],
  place: { devices: [] },
  isCreator: false,
  editPlaceId: null,
  selectedPlace: null,
  selectedArea: null,
  showIndoor: false,
  selectedAreaMenu: null,
  showDevices: false,
  searchName: '',
  placesOrderFilterd: [],
};

const slice = createSlice({
  name: 'place',
  initialState,
  reducers: {
    // START LOADING
    startLoading(state) {
      state.isLoading = true;
    },
    resetPlaceStore(state) {
      Object.assign(state, initialState);
    },
    // HAS ERROR
    hasError(state, action) {
      state.isLoading = false;
      state.error = action.payload;
    },

    // GET PLACES
    getPlacesSuccess(state, action) {
      state.isLoading = false;
      state.places = action.payload;
      const c = [];
      flatChilds(c, action.payload);
      state.placesOrder = c;
      // console.log(c);
    },

    // SET SEARCH
    setSearchName(state, action) {
      state.searchName = action.payload;
      state.placesOrderFilterd = state.placesOrder.filter((place) =>
        place.name.toLowerCase().includes(action.payload.toLowerCase())
      );
    },

    // GET PLACE
    getPlaceSuccess(state, action) {
      state.isLoading = false;
      state.place = action.payload;
    },
    setShowIndoor(state, action) {
      state.showIndoor = action.payload;
    },
    setShowDevices(state, action) {
      state.showDevices = action.payload;
    },
    setIsCreator(state, action) {
      state.isCreator = action.payload;
    },
    setPlaceFeatures(state, action) {
      state.place.features = Object.assign(action.payload);
    },
    setSelectedArea(state, action) {
      state.selectedArea = action.payload;
    },
    setSelectedAreaMenu(state, action) {
      state.selectedAreaMenu = action.payload;
    },
    setEditPlaceId(state, action) {
      state.editPlaceId = action.payload;
      const place = state.placesOrder.filter((v) => v.id === action.payload)[0];
      const features = {};
      if (place) {
        place.areas.forEach((element) => {
          features[element.id] = { ...JSON.parse(JSON.stringify(element, undefined, 2)) };
        });
        // console.log(JSON.parse(JSON.stringify(place)));
        state.place = Object.assign(JSON.parse(JSON.stringify(place)), { features });
      }
    },
    setParentPlace(state, action) {
      state.place.parent = action.payload;
    },
    clearCreatorForm(state) {
      state.place = { features: {}, devices: [] };
      state.isCreator = false;
      state.editPlaceId = null;
      state.selectedPlace = null;
      state.selectedArea = null;
      state.showIndoor = false;
      state.showDevices = false;
    },
    addDevice(state, action) {
      if (state.place.devices) state.place.devices = [...state.place.devices, action.payload];
      else state.place.devices = [action.payload];
    },
    removeDevice(state, action) {
      state.place.devices = state.place.devices.filter((d) => d.id !== action.payload.id);
    },
    clearDevices(state) {
      state.place.devices = [];
    },
  },
});

// Reducer
export default slice.reducer;

// Actions
export const {
  resetPlaceStore,
  getPlacesSuccess,
  setSearchName,
  getPlaceSuccess,
  setShowIndoor,
  setShowDevices,
  setIsCreator,
  setPlaceFeatures,
  setSelectedArea,
  setSelectedAreaMenu,
  setEditPlaceId,
  setParentPlace,
  clearCreatorForm,
  addDevice,
  removeDevice,
  clearDevices,
} = slice.actions;

// ----------------------------------------------------------------------

export function getPlaces() {
  return async () => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await axios.get('/places');
      dispatch(slice.actions.getPlacesSuccess(response.data));
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}

// ----------------------------------------------------------------------

export function getPlace(id) {
  return async () => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await axios.get(`/places/${id}`);
      dispatch(slice.actions.getPlacesSuccess(response.data));
    } catch (error) {
      console.error(error);
      dispatch(slice.actions.hasError(error));
    }
  };
}
